// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseValidationInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Validation component
 */
!(function () {
  require('share/utils/Izenda.StringUtilities');

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');

  var LicenseInfoConstants  = require('logic/data/Izenda.LicenseInfoConstants');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableSecuredInput = Validator()(require('share/components/controls/Izenda.SecuredInput'));

  var LicenseValidationInput = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },
    /**
     * Render content
     */
    render: function () {
      var licenseInfo = this.props.item;
      var props = this.props;
      var localization = props.localization;
      var inputClasses = classnames('form-control', 
          { 'izenda-LicenseChecker-validationInput': licenseInfo.isValidLicense });

      return (
      <fieldset className='form-horizontal izenda-LicenseValidation'
                disabled={props.validatedConnection ? null : 'disabled'}>

        {/* license mode */}
        <div className="form-group">
          <label className="control-label col-md-2">{localization.getText("LICENSE_CHECKER_LABEL_LICENSE_MODE")}</label>
          <div className="col-md-10">
            <div className="u_table">
              <span className="u_tableCell u_alignMiddle">{localization.getText("LICENSE_CHECKER_LABEL_OFFLINE")}</span>
              <div className="izenda-Switch u_marginLeftRight">
                <input
                  type="checkbox"
                  id="izenda-Switch-checkbox"
                  className="izenda-Switch-checkbox"
                  onChange={this.onChangeLicenseMode}
                  checked={!!licenseInfo.licenseOnlineMode}
                />
                <label className="izenda-Switch-label" htmlFor="izenda-Switch-checkbox"></label>
              </div>
              <span className="u_tableCell u_alignMiddle">{localization.getText("LICENSE_CHECKER_LABEL_ONLINE")}</span>
            </div>
          </div>
        </div>

        {/* license key*/}
        <div className='form-group'>
          <label className="col-md-2 control-label validation required">{localization.getText("LICENSE_CHECKER_LABEL_LICENSE_KEY")}</label>
          <div className="col-md-10">
            <ValidatableSecuredInput
              className={inputClasses}
              onReset={this.resetLicenseInfo}
              onChange={this.onChangeLicenseKey}
              value={licenseInfo.licenseKey}
              secure={licenseInfo.validatedLicense}
              validations={LicenseInfoConstants.LICENSE_KEY_CONSTRAINT}
              field='licenseKey'
              maxLength='MAX'
              />
            {this.renderSuccessIcon(licenseInfo)}
          </div>
        </div>


        {/* token */}
        {
          (licenseInfo.licenseOnlineMode)
          ? null
          : (<div className='form-group'>
              <label className="col-md-2 control-label validation required">{localization.getText("LICENSE_CHECKER_LABEL_TOKEN")}</label>
              <div className="col-md-10">
                <ValidatableSecuredInput
                  className={inputClasses}
                  onReset={this.resetLicenseInfo}
                  onChange={this.onChangeToken}
                  value={licenseInfo.tokenKey}
                  secure={licenseInfo.validatedLicense}
                  validations={LicenseInfoConstants.TOKEN_CONSTRAINT}
                  field='tokenKey'
                  maxLength='MAX'
                  />
                {this.renderSuccessIcon(licenseInfo)}
              </div>
            </div>)
        }

        {this.renderLicenseStatus()}

        </fieldset>
      );
    },

    renderSuccessIcon : function (licenseInfo) {
      return licenseInfo.isValidLicense
      ? (<div className='u-posAbsolute success-color u-iconAfterInput'>
            <span className="icon-ok" />
          </div>)
      : null
    },

    renderLicenseStatus: function () {
      var licenseInfo = this.props.item;

      if (!licenseInfo.validatedLicense || !licenseInfo.isValidLicense) {
        return null;
      }

      // license will be valide in the future
      if (licenseInfo.numberOfDayToValid > 0) {
        return (
          <div className='form-group'>
            <div className="col-md-offset-2 col-md-10">
              <div className='alert alert-info' role='alert'>
                {String.format(LicenseInfoConstants.MESSAGE.MG07a,
                 String.formatDate(licenseInfo.startDate),
                 String.formatDate(licenseInfo.endDate))}
              </div>
            </div>
          </div>
        );
      }

      return null;
    },

    onChangeLicenseMode: function (e) {
      var licenseInfo = this.props.item;
      var newMode = e.target.checked;

      if (licenseInfo.validatedLicense && licenseInfo.isValidLicense) {
        //show message
        this.props.confirmFn('Confirmation', {
          description: getMessage()
        }).then(function () {
          this.updateLicenseMode(newMode);
          //reset validate value license/token
          this.resetLicenseValidation();
        }.bind(this));

      } else {
        this.updateLicenseMode(newMode);
      }

      /**
       * get error message when fail
       * @return {String} message show on popup
       */
      function getMessage() {
        var msgId = newMode ? 'MG01b' : 'MG01a';
        return LicenseInfoConstants.MESSAGE[msgId];
      }

    },

    updateLicenseMode: function (licenseMode) {
      this.updateLicenseInfo('licenseOnlineMode', licenseMode);
      this.updateLicenseInfo('licenseKey', '');
      this.updateLicenseInfo('tokenKey', '');
    },

    resetLicenseInfo: function () {
      var licenseInfo = this.props.item;
      if (licenseInfo.validatedLicense) {
        this.updateLicenseInfo('licenseKey', '');
        this.updateLicenseInfo('tokenKey', '');
        this.props.validation.reset('licenseKey');
        this.props.validation.reset('tokenKey');
      }
    },

    onChangeLicenseKey: function (e) {
      this.updateLicenseInfo('licenseKey', e.target.value);
    },

    onChangeToken: function (e) {
      this.updateLicenseInfo('tokenKey', e.target.value);
    },

    updateLicenseInfo: function (key, value) {
      var licenseInfo = this.props.item;
      licenseInfo.updateLicenseInfoByKey(key, value);
    },

    resetLicenseValidation: function(){
      var valManager = this.props.validation;
      valManager.reset('licenseKey');
      valManager.reset('tokenKey');
    }

  });

  module.exports = connect()(LicenseValidationInput);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.LicenseValidationInput.jsx